import { useQuery } from "@tanstack/react-query";
import { fetchMonth, fetchMyPayslip, fetchMyPayslips, fetchPayslip, fetchProfiles } from "../../api/payroll";
import { useServices } from "../../app/services";
import type { Scope } from "./kit";

export function useProfiles(sc: Scope) {
  const { client } = useServices();
  return useQuery({ queryKey: ["payroll", "profiles", ...sc.scopeKey], queryFn: () => fetchProfiles(client, sc.branchId), enabled: sc.ctx.has("payroll.view"), retry: false });
}
/** staffId → name for tables. Falls back to the id when the caller cannot list profiles. */
export const nameMap = (entries: ReadonlyArray<{ staffId: string; name: string }> | undefined) => new Map((entries ?? []).map((e) => [e.staffId, e.name]));

export function useMonth(sc: Scope, month: string) {
  const { client } = useServices();
  return useQuery({ queryKey: ["payroll", "month", month, ...sc.scopeKey], queryFn: () => fetchMonth(client, month, sc.monthBranchId!), enabled: !!sc.monthBranchId, retry: false });
}
export function usePayslip(sc: Scope, id: string, own: boolean) {
  const { client } = useServices();
  return useQuery({ queryKey: ["payroll", own ? "my-payslip" : "payslip", id, ...sc.scopeKey], queryFn: () => (own ? fetchMyPayslip(client, id) : fetchPayslip(client, id)), retry: false });
}
export function useMyPayslips(sc: Scope) {
  const { client } = useServices();
  return useQuery({ queryKey: ["payroll", "my-payslips", ...sc.scopeKey], queryFn: () => fetchMyPayslips(client), retry: false });
}
